import React from 'react';
import _ from 'lodash';
import Select from 'react-select';
import { Panel, Modal } from 'react-bootstrap';
import Alert from './Alert';
import '../assets/scss/lifeline.scss';

var Api = require('./Config');

const LIFELINE_JOURNEY_ID = 24;

export default class LifeLineManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: [],
      selected_app: null,
      app_code_journey_data: null,
      guidance_response_with_path: '',
      guidance_response_without_path: '',
      surveys: [],
      survey_modal: {
        show: false,
        survey_id: null,
      },
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.getApps();
  }

  getApps() {
    Api.getApps()
      .then((apps) => {
        const allApps = _.map(apps, (a) => {
          a.clubname = unescape(a.clubname);
          return a;
        });

        this.setState({
          apps: allApps,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getAppCodeJourneyData(app_code, jid) {
    Api.getAppCodeJourney(app_code, jid)
      .then((details) => {
        if (details) {
          this.setState({
            app_code_journey_data: details,
            guidance_response_with_path: details.guidance_response_with_path,
            guidance_response_without_path: details.guidance_response_without_path,
          });
        } else {
          this.setState({
            app_code_journey_data: null,
            guidance_response_with_path: '',
            guidance_response_without_path: '',
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getSurveys(app_code, jid) {
    Api.getAppCodeJourneySurvey(app_code, jid)
      .then((surveys) => {
        this.setState({
          surveys: surveys,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  appSelected(app) {
    this.setState({
      selected_app: app,
    });
    if (app) {
      this.getSurveys(app.club_id, LIFELINE_JOURNEY_ID);
      this.getAppCodeJourneyData(app.club_id, LIFELINE_JOURNEY_ID);
    } else {
      this.setState({
        surveys: [],
        app_code_journey_data: null,
        guidance_response_with_path: '',
        guidance_response_without_path: '',
      });
    }
  }

  handleToggle(survey) {
    var newSurveys = this.state.surveys.map((item) => {
      if (item.survey_id === survey.survey_id) {
        item.enable = survey.enable === 1 ? 0 : 1;
      }
      return item;
    });

    this.setState({ surveys: newSurveys });
  }

  handleModalOpen(survey_id) {
    this.setState({
      survey_modal: {
        show: true,
        survey_id: survey_id,
      },
    });
  }

  handleModalClose() {
    this.setState({
      survey_modal: {
        show: false,
        survey_id: null,
      },
    });
  }

  handleGuidancePathChange(changeType, survey_id, guidance_id, index, path_type, value) {
    var newSurveys = this.state.surveys.map((item) => {
      if (item.survey_id === survey_id) {
        item.guidance.map((guidance) => {
          if (guidance.id === guidance_id) {
            switch (changeType) {
              case 'add':
                guidance.path = this.addGuidancePath(guidance.path);
                break;
              case 'remove':
                guidance.path.splice(index, 1);
                break;
              case 'update':
                guidance.path[index][path_type] = value;
                break;
            }
          }
        });
      }
      return item;
    });

    this.setState({ surveys: newSurveys });
  }

  addGuidancePath(guidancePath) {
    let newPath = {
      path_text: '',
      path_url: '',
    };

    if (guidancePath !== null) {
      guidancePath.push(newPath);
    } else {
      guidancePath = [newPath];
    }

    return guidancePath;
  }

  async handleSubmit() {
    try {
      // update guidance response
      let result = await Api.saveGuidanceResponse(
        this.state.selected_app.club_id,
        LIFELINE_JOURNEY_ID,
        this.state.guidance_response_with_path,
        this.state.guidance_response_without_path
      );

      if (!result.SUCCESS) {
        this.alert.open('Error', 'Something went wrong.');
        return;
      }

      let app_code_journey_id;
      if (this.state.app_code_journey_data == null) {
        app_code_journey_id = result.app_code_journey_id;
        this.setState({
          app_code_journey_data: {
            id: app_code_journey_id,
          },
        });
      } else {
        app_code_journey_id = this.state.app_code_journey_data.id;
      }

      let survey_ids_to_save = [];
      let survey_ids_to_remove = [];
      let guidances = [];

      this.state.surveys.map((survey) => {
        if (survey.enable === 1) {
          survey_ids_to_save.push(survey.survey_id);
          survey.guidance.map((guide) => {
            let validPaths = [];
            if (guide.path !== null) {
              validPaths = guide.path.filter((path) => {
                return path.path_text.length > 0 && path.path_url.length > 0;
              });
            }

            guidances.push({
              survey_id: survey.survey_id,
              guidance_id: guide.id,
              path: validPaths,
            });
          });
        } else {
          survey_ids_to_remove.push(survey.survey_id);
        }
      });

      if (survey_ids_to_remove.length > 0) {
        result = await Api.removeAppCodeJourneySurvey(app_code_journey_id, survey_ids_to_remove);
        if (!result.SUCCESS) {
          this.alert.open('Error', 'Something went wrong.');
          return;
        }
      }

      if (survey_ids_to_save.length > 0) {
        result = await Api.saveAppCodeJourneySurvey(app_code_journey_id, survey_ids_to_save);
        if (!result.SUCCESS) {
          this.alert.open('Error', 'Something went wrong.');
          return;
        }
      }

      if (guidances.length > 0) {
        result = await Api.saveGuidancePaths(app_code_journey_id, guidances);
        if (!result.SUCCESS) {
          this.alert.open('Error', 'Something went wrong.');
          return;
        }
      }

      this.alert.open('Success', 'Survey successfully saved.');
    } catch (err) {
      console.log(err);
      this.alert.open('Error', 'Something went wrong.');
    }
  }

  renderGuidancePathInput(path, guidance_id, survey_id, idx) {
    return (
      <div key={idx} className="row form-group guidance-path">
        <div className="col-md-4 col-md-offset-1">
          <input
            type="text"
            className="form-control"
            value={path.path_text || ''}
            placeholder="Path Text"
            onChange={(e) => {
              this.handleGuidancePathChange('update', survey_id, guidance_id, idx, 'path_text', e.target.value);
            }}
          />
        </div>
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            value={path.path_url || ''}
            placeholder="Path URL"
            onChange={(e) => {
              this.handleGuidancePathChange('update', survey_id, guidance_id, idx, 'path_url', e.target.value);
            }}
          />
        </div>
        <div className="col-md-2">
          <button
            className="btn btn-danger"
            onClick={() => {
              this.handleGuidancePathChange('remove', survey_id, guidance_id, idx);
            }}
          >
            {' '}
            Remove{' '}
          </button>
        </div>
      </div>
    );
  }

  renderGuidance(guidance, survey_id) {
    return (
      <div key={guidance.id}>
        <h4>{guidance.name}</h4>
        {guidance.path &&
          guidance.path.map((path, index) => this.renderGuidancePathInput(path, guidance.id, survey_id, index))}
        <div className="row">
          <div className="col-md-11 col-md-offset-1">
            <button
              className="btn btn-primary add-guidance"
              onClick={() => {
                this.handleGuidancePathChange('add', survey_id, guidance.id);
              }}
            >
              {' '}
              + Add Guidance Path{' '}
            </button>
          </div>
        </div>
        <hr></hr>
      </div>
    );
  }

  renderListItem(survey) {
    let itemId = 'panel-survey-' + survey.survey_id;
    let enabledClass = survey.enable === 1 ? 'survey-enable' : '';

    return (
      <Panel key={itemId} id={itemId} className={enabledClass} expanded={survey.enable === 1} onToggle={() => {}}>
        <Panel.Heading>
          <div className="survey-description">
            <label class="switch">
              <input type="checkbox" checked={survey.enable === 1} onChange={() => this.handleToggle(survey)} />
              <span class="slider round"></span>
            </label>
            <Panel.Title> {survey.description} </Panel.Title>
          </div>
          <button onClick={() => this.handleModalOpen(survey.survey_id)}>View Survey</button>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            {survey.guidance && survey.guidance.map((guidance) => this.renderGuidance(guidance, survey.survey_id))}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }

  render() {
    const { selected_app, apps } = this.state;
    return (
      <div>
        <h3>LifeLine Management</h3>
        <div className="row lifeline-management">
          <div className="col-md-12">
            <div className="col-md-4 form-group select-app">
              <label>Select App:</label>
              <Select
                onChange={(obj) => {
                  this.appSelected(obj);
                }}
                value={selected_app}
                getOptionValue={(a) => a.club_id}
                getOptionLabel={(a) => a.clubname}
                options={apps}
              />
            </div>
          </div>
          {this.state.selected_app && (
            <div className="col-md-12">
              <div className="question-sets">
                <h4>Question Sets</h4>
                {this.state.surveys.map((survey) => this.renderListItem(survey))}
              </div>
              <hr></hr>
              <div>
                <h4>Response messages</h4>
                <div className="form-group">
                  <label>Response Message with Guidance Path</label>
                  <p>{'Add <PATHS> as a placeholder for the guidance paths.'}</p>
                  <textarea
                    value={this.state.guidance_response_with_path}
                    onChange={(e) => {
                      this.setState({ guidance_response_with_path: e.target.value });
                    }}
                    type="text"
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>
                    Response Message Message <b>without</b> Guidance Path
                  </label>
                  <textarea
                    value={this.state.guidance_response_without_path}
                    onChange={(e) => {
                      this.setState({ guidance_response_without_path: e.target.value });
                    }}
                    type="text"
                    className="form-control"
                  />
                </div>
              </div>
              <button className="btn btn-primary btn-lg" onClick={this.handleSubmit}>
                Save
              </button>
              <button
                className="btn btn-info btn-lg"
                onClick={() => {
                  this.setState({
                    selected_app: null,
                  });
                }}
              >
                Cancel
              </button>
            </div>
          )}
        </div>
        <Alert
          ref={(ref) => {
            this.alert = ref;
          }}
        />
        <Modal show={this.state.survey_modal.show} onHide={() => this.handleModalClose()}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="text-center">
            <iframe
              title="surveyCodeFrame"
              style={{ width: '340', height: 500 }}
              frameBorder="none"
              src={`${Api.getHost()}docportal_api/surveypage_show.php?SURVEY=${this.state.survey_modal.survey_id}`}
            />
          </Modal.Body>
          <Modal.Footer>
            <button onClick={() => this.handleModalClose()} className="btn btn-default">
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
